'use strict';

/* global angular */

/**
 * The identity module contains methods used to set and retrieve the identity of the current user
 * as well as app level information like environment.
 */

var ingestor = angular.module('common.ingestor', ['common.identity']);

var IngestorService = require('./IngestorService');

ingestor.service('IngestorService', IngestorService);

// // ## Initialize on module load
// ingestor.run(['IngestorService', function (IngestorService) {
//   IngestorService.init();
// }]);



// WEBPACK FOOTER //
// ./src/common/ingestor/index.js